/* cardframes — Katalog für den Shop-Konfigurator.
   Erzeugt vom Inlay-Konfigurator, nicht von Hand pflegen.
   Enthält bewusst keine Fertigungsmaße: kein Laserabzug, keine
   exakten Eckradien, keine Schnittmaße. */
window.CARDFRAMES_KATALOG = {
  "stand": "2026-08-02",
  "rahmen": [
    { "id": "f13x18", "name": "13 × 18 cm", "w": 130, "h": 180, "preis": 22.9 },
    { "id": "f21x30", "name": "21 × 30 cm", "w": 210, "h": 300, "preis": 32.9 },
    { "id": "f28x55", "name": "28 × 55 cm", "w": 280, "h": 550, "preis": 59.9 },
    { "id": "f30x40", "name": "30 × 40 cm", "w": 300, "h": 400, "preis": 38.9 },
    { "id": "f40x50", "name": "40 × 50 cm", "w": 400, "h": 500, "preis": 59.9 },
    { "id": "f46x61", "name": "46 × 61 cm", "w": 460, "h": 610, "preis": 67.9 },
    { "id": "f50x70", "name": "50 × 70 cm", "w": 500, "h": 700, "preis": 79.9 }
  ],
  "farben": [
    { "name": "Schwarz", "hex": "#17171b", "dunkel": true },
    { "name": "Weiß", "hex": "#ffffff", "dunkel": false }
  ],
  "halter": [
    { "id": "psa", "name": "PSA", "art": "slab", "farbe": "#c8352f", "w": 80, "h": 135 },
    { "id": "bgs", "name": "BGS", "art": "slab", "farbe": "#2b4f9e", "w": 83, "h": 130 },
    { "id": "sgc", "name": "SGC", "art": "slab", "farbe": "#26262e", "w": 86, "h": 138 },
    { "id": "cgc", "name": "CGC", "art": "slab", "farbe": "#12867a", "w": 80, "h": 135 },
    { "id": "gsg", "name": "GSG", "art": "slab", "farbe": "#6a48b5", "w": 81, "h": 139 },
    { "id": "aog", "name": "AOG", "art": "slab", "farbe": "#cf8a1c", "w": 77, "h": 128 },
    { "id": "magnet", "name": "Magnetholder", "art": "magnet", "farbe": "#8f97a6", "w": 73, "h": 110 }
  ],
  "regeln": { "rand": 6, "steg": 3, "tiefe": 30.0 }
};
